import scrollTo from 'scroll-to'

export const reinsert = (arr, from, to) => {
  const _arr = arr.slice(0)
  const val = _arr[from]
  _arr.splice(from, 1)
  _arr.splice(to, 0, val)
  return _arr
}

export const createChunks = (array, size) => {
  const chunked_arr = []
  let index = 0
  while (index < array.length) {
    chunked_arr.push(array.slice(index, size + index))
    index += size
  }
  return chunked_arr
}

export const getRandomInt = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min)) + min
  //The maximum is exclusive and the minimum is inclusive
}

export const clamp = (n, min, max) => Math.max(Math.min(n, max), min)

export const leadingZero = value => {
  return ('0' + value).slice(-2)
}

export const toggleBodyScroll = status => {
  const el = document.querySelector('html').classList

  if (!status) {
    el.add('hide-scroll')
  } else {
    el.remove('hide-scroll')
  }
}

export const scrollTop = (top, dur) => {
  window.scroll(0, 0)
  // scrollTo(0, top || 0, {
  //   ease: 'out-circ',
  //   duration: dur || 600
  // })
}

export const scrollAnim = (top = 0, dur = 600) => {
  scrollTo(0, top, {
    ease: 'out-circ',
    duration: dur
  })
}

export const shuffleArray = array => array.sort(() => .5 - Math.random())
export const getRandomItemFromArray = (array, count) => shuffleArray(array).slice(0, count)

export function transformTime(miliseconds) {
  const seconds = (`0${(Math.floor((miliseconds / 1000) % 60) % 60)}`).slice(-2)
  const minutes = (`0${Math.floor((miliseconds / 60000) % 60)}`).slice(-2)
  const hours = (`0${Math.floor((miliseconds / 3600000) % 60)}`).slice(-2)

  // return (
  //   <>
  //     {hours !== '00' && <><span className="bold">{hours} uur</span> en </> }
  //     {minutes !== '00' && <><span className="bold">{minutes} minuten</span> en </> }
  //     <span className="bold">{seconds} seconden</span>
  //   </>
  // )

  const hLabel = `${hours} uur`
  const mLabel = `${minutes} minuten`
  const sLabel = `${seconds} seconden`

  return `${hours !== '00' ? hLabel : ''} ${minutes !== '00' ? mLabel : ''} ${seconds !== '00' ? sLabel : ''}`
}